// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2Vnin","addWidgetButton":"Header_addWidgetButton__1BzqQ","dashboardTabs":"Header_dashboardTabs__2o0K9","active":"Header_active__pPCMx"};